import mitt from 'mitt';

const eventBus = mitt();

export default eventBus;
export { eventBus };

// class EventBus {
//     eventMap = new Map();
//     channel = new BroadcastChannel('__event-bus');

//     register(eventName, callback) {
//         if (!this.eventMap.has(eventName)) {
//             this.eventMap.set(eventName, []);
//         }
//         this.eventMap.get(eventName).push(callback);
//     }
//     tryRunCallback(eventName, data, source) {
//         if (!this.eventMap.has(eventName)) return;
//         this.eventMap.get(eventName).forEach((callback) => {
//             callback(data, source);
//         });
//     }

//     // 广播事件
//     emit(eventName, data) {
//         this.tryRunCallback(eventName, data);
//         // 跨标签页 发送消息
//         this.channel.postMessage({ eventName, data, source: location.href });
//     }
//     // 订阅事件
//     on(eventName, callback) {
//         this.register(eventName, callback);
//         // 跨标签页 接收订阅消息
//         this.channel.onmessage = (event) => {
//             const data = event.data;
//             this.tryRunCallback(data.eventName, data.data, data.source);
//         };
//     }
//     // 移除某个订阅事件
//     off(eventName, callback) {
//         if (!this.eventMap.has(eventName)) return;
//         const callbacks = this.eventMap.get(eventName);
//         this.eventMap.set(eventName, callbacks.filter((cb) => cb !== callback));
//     }
//     // 清除某个事件的所有订阅
//     clear(eventName) {
//         this.eventMap.delete(eventName);
//     }
//     // 清除所有订阅事件
//     clearAll() {
//         this.eventMap = new Map();
//     }
// }

// const eventBus = new EventBus();

// export default eventBus;
// export { eventBus };
